import Vue from 'vue'
import store from '@/store/store.js'
import analytics from '@/services/analytics.js'

export const loadBaseComponents = () => {
  let requireComponent = require.context("@/components/Base/", true, /\.vue$/)

  requireComponent.keys().forEach((fileName) => {
    let baseComponentConfig = requireComponent(fileName)
    baseComponentConfig = baseComponentConfig.default || baseComponentConfig

    let baseComponentName = baseComponentConfig.name || (
        fileName
            .replace(/^.+\//, '')
            .replace(/\.\w+$/, '')
    )

    Vue.component(baseComponentName, baseComponentConfig)
  })
}

export const loadIcons = () => {
  let requireComponent = require.context("@/components/Icons/", true, /\.vue$/)

  requireComponent.keys().forEach((fileName) => {
    let baseComponentConfig = requireComponent(fileName)
    baseComponentConfig = baseComponentConfig.default || baseComponentConfig

    let baseComponentName = baseComponentConfig.name || (
        fileName
            .replace(/^.+\//, '')
            .replace(/\.\w+$/, '')
    )

    Vue.component(baseComponentName, baseComponentConfig)
  })
}

export const bootstrap = async () => {
  let currentUser = store.getters['auth/currentUser']

  analytics.setUserId(currentUser.id)
  analytics.setUserName(currentUser.name)

  store.commit('feed/setGroupId', currentUser.group_id)
  
  await store.dispatch('children/load', currentUser.group_id)
  await store.dispatch('geofence/loadNamedLocations', currentUser.group_id)
  await store.dispatch('categories/loadCustom', currentUser.group_id)
  await store.dispatch('requests/load', currentUser.group_id)
  await store.dispatch('categories/load')
  await store.dispatch('feed/load', {
    scan_direction_forward: false
  })
}
